type ParamKeyValuePair = [string, string];

export type URLSearchParamsInit = string | ParamKeyValuePair[] | Record<string, string | string[]> | URLSearchParams;

/**
 * Build a `URLSearchParams` from the union of shapes React Router's
 * `createSearchParams` / `setSearchParams` accept (string, tuple list, record,
 * or an existing `URLSearchParams`).
 */
export function createSearchParams(init: URLSearchParamsInit = ''): URLSearchParams {
  if (typeof init === 'string' || Array.isArray(init) || init instanceof URLSearchParams) {
    return new URLSearchParams(init);
  }

  return new URLSearchParams(
    Object.keys(init).reduce<ParamKeyValuePair[]>((memo, key) => {
      const value = init[key];
      return memo.concat(Array.isArray(value) ? value.map(v => [key, v] as ParamKeyValuePair) : [[key, value]]);
    }, []),
  );
}
